/**
 * PendingActivationCard — full-page waiting state for users whose seat was
 * bootstrapped with the PENDING role (zero permissions).
 *
 * Rendered by DashboardLayout in place of the routed page content, so every
 * route shows this card until an organization admin assigns a real role.
 * Logout and language controls stay available in the surrounding NavHeader.
 */

import { Hourglass } from "lucide-react"
import { useTranslations } from "@/hooks/useTranslations"

export function PendingActivationCard() {
	const t = useTranslations()

	return (
		<div className="flex h-full items-center justify-center">
			<div className="w-full max-w-md rounded-xl border bg-card p-8 text-center shadow-sm">
				<div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-amber-200 bg-amber-50">
					<Hourglass className="h-5 w-5 text-amber-600" />
				</div>
				<h1 className="mt-4 text-lg font-semibold text-foreground">
					{t("auth.pendingActivation.title")}
				</h1>
				<p className="mt-2 text-sm leading-relaxed text-muted-foreground">
					{t("auth.pendingActivation.description")}
				</p>
				<p className="mt-4 text-xs text-muted-foreground/80">
					{t("auth.pendingActivation.hint")}
				</p>
			</div>
		</div>
	)
}
